export default __webpack_public_path__ + "static/media/lotto.8eb77002.png";